export enum TransformerResponseCodes {
  GUEST_TBA = 'GTBA',
  REMOVE_FISCOD_ON_FOREIGN_GUEST = 'RFFG',
}
